import school_1 from '../../assets/images/school-1.svg';
import account_box from '../../assets/images/account-box-program-highlights.svg';
import business_center from '../../assets/images/business-center.svg';

class ProgramHighlights extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
        <div class="frame-111-11">
            <div class="frame-31">
                <div class="frame">
                    <div class="frequently-asked-questions circularstd-bold-prussian-blue-36px">From Community Colleges</div>
                </div>
            </div>
            <div class="frame-631029">
                <div class="frame-63103">
                    <div class="frame-631030">
                        <img class="school" src="${school_1}" alt="school" />
                    </div>
                    <div class="frame-631024">
                        <div class="hands-on-learning circularstd-bold-prussian-blue-24px">Hands-On Learning</div>
                        <p class="learn-by-doing-with gilroy-medium-oxford-blue-18px">
                        Learn by doing with on-the-job training in real software technology projects.
                        </p>
                    </div>
                </div>
                <div class="frame-63103">
                    <div class="frame-631030-1frame-631030-3">
                        <img class="account_box" src="${account_box}" alt="account_box" />
                    </div>
                    <div class="frame-631024">
                        <div class="expert-mentors circularstd-bold-prussian-blue-24px">Expert Mentors</div>
                        <p class="learn-by-doing-with gilroy-medium-oxford-blue-18px">
                        Get guidance and insights from experienced professionals in the field.
                        </p>
                    </div>
                </div>
                <div class="frame-63103">
                    <div class="frame-631030-2frame-631030-3">
                        <img class="business_center" src="${business_center}" alt="business_center" />
                    </div>
                    <div class="frame-631024">
                        <div class="career-opportunities circularstd-bold-prussian-blue-24px">Career Opportunities</div>
                        <p class="learn-by-doing-with gilroy-medium-oxford-blue-18px">
                        Open doors to meaningful careers in the ever-growing tech industry.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        `;
    }
}


customElements.define('program-highlights', ProgramHighlights);